let BASE = '/v2/api/aawz-partners/project-management'

export const endpoint = {
  folders: BASE + '/folders',
  folderById: function (id) { return BASE + '/folders/' + id },
  foldersReorder: BASE + '/folders/reorder',
  // Reparent da pasta (mover / promover a raiz). Path próprio em vez de um campo
  // do PUT: renomear e mover têm gates de permissão diferentes.
  folderMove: function (id) { return BASE + '/folders/' + id + '/move' },

  sprintsByFolder: function (folderId) { return BASE + '/folders/' + folderId + '/sprints' },
  sprintById: function (id) { return BASE + '/sprints/' + id },
  sprintsReorder: BASE + '/sprints/reorder',

  tasks: BASE + '/tasks',
  listPreferences: BASE + '/list-preferences',
  taskById: function (id) { return BASE + '/tasks/' + id },
  tasksReorder: BASE + '/tasks/reorder',
  tasksMove: BASE + '/tasks/move',
  // Delete em lote (T006, US-1) — substitui o loop de N DELETE individuais
  // por UMA requisicao. `taskById` continua sendo usado pelo delete de UMA
  // tarefa (`deleteTask`).
  tasksBatch: BASE + '/tasks/batch',

  // Resolve short-link prefixes (8-char UUID truncations) back to full UUIDs.
  // Aceita ?l=<folderPrefix>&s=<sprintPrefix>&t=<taskPrefix> (todos opcionais),
  // resolução hierárquica (sprint dentro do folder, task dentro do folder/sprint),
  // respeitando visibilidade de tarefa. Retorna { folderId, sprintId, taskId }.
  resolve: BASE + '/resolve',

  // Visões rápidas (cross-pasta/cross-sprint). `quickViewTasks` aceita
  // ?view=<mine|today|next7|overdue|noDue> e devolve a MESMA árvore de
  // get_tasks; `quickViewCounts` devolve { mine, today, next7, overdue, noDue }.
  quickViewTasks: BASE + '/tasks/quick-view',
  quickViewCounts: BASE + '/tasks/quick-view/counts',

  taskComments: function (taskId) { return BASE + '/tasks/' + taskId + '/comments' },
  commentById: function (id) { return BASE + '/comments/' + id },

  commentAttachments: function (commentId) { return BASE + '/comments/' + commentId + '/attachments' },
  commentAttachmentById: function (commentId, attId) { return BASE + '/comments/' + commentId + '/attachments/' + attId },
  commentAttachmentDownload: function (commentId, attId) { return BASE + '/comments/' + commentId + '/attachments/' + attId + '/download' },

  taskAttachments: function (taskId) { return BASE + '/tasks/' + taskId + '/attachments' },
  taskAttachmentById: function (taskId, attId) { return BASE + '/tasks/' + taskId + '/attachments/' + attId },
  taskAttachmentDownload: function (taskId, attId) { return BASE + '/tasks/' + taskId + '/attachments/' + attId + '/download' },

  taskTags: function (taskId) { return BASE + '/tasks/' + taskId + '/tags' },
  taskTagById: function (taskId, tagId) { return BASE + '/tasks/' + taskId + '/tags/' + tagId },

  taskAssignees: function (taskId) { return BASE + '/tasks/' + taskId + '/assignees' },
  taskAssigneeById: function (taskId, profissionalId) { return BASE + '/tasks/' + taskId + '/assignees/' + profissionalId },

  taskChecklists: function (taskId) { return BASE + '/tasks/' + taskId + '/checklists' },
  checklistItems: function (checklistId) { return BASE + '/checklists/' + checklistId + '/items' },
  checklistItemsReorder: function (checklistId) { return BASE + '/checklists/' + checklistId + '/items/reorder' },
  checklistItemById: function (id) { return BASE + '/checklist-items/' + id },

  tags: BASE + '/tags',
  tagById: function (id) { return BASE + '/tags/' + id },

  // Per-folder custom statuses (customizar-status-tarefas).
  // GET/POST on the folder collection; PUT/DELETE on the status detail;
  // POST on the reorder endpoint (POST, não PATCH, para evitar preflight CORS).
  // Two-layer scoping (id_escritorio + id_folder) is enforced server-side.
  folderStatuses: function (folderId) { return BASE + '/folders/' + folderId + '/statuses' },
  statusById: function (id) { return BASE + '/statuses/' + id },
  folderStatusesReorder: function (folderId) { return BASE + '/folders/' + folderId + '/statuses/reorder' },

  overviewStats: BASE + '/overview/stats',
  overviewOverdue: BASE + '/overview/overdue-tasks',
  overviewMembers: BASE + '/overview/distribution/members',
  overviewClients: BASE + '/overview/distribution/clients',
  overviewChartMonthly: BASE + '/overview/chart/monthly',
  overviewWeeklyDue: BASE + '/overview/weekly-due',
  overviewWeeklyDone: BASE + '/overview/weekly-done',

  assignees: BASE + '/tasks/assignees',

  customFields: BASE + '/custom-fields',
  customFieldById: function (id) { return BASE + '/custom-fields/' + id },
  taskCustomFieldValue: function (taskId, fieldId) { return BASE + '/tasks/' + taskId + '/custom-fields/' + fieldId },

  templates: BASE + '/templates',
  templateById: function (id) { return BASE + '/templates/' + id },
  templateNodes: function (templateId) { return BASE + '/templates/' + templateId + '/nodes' },
  templateNodesReorder: function (rootId) { return BASE + '/templates/' + rootId + '/reorder' },
  templateInstantiate: function (templateId) { return BASE + '/templates/' + templateId + '/instantiate' },
  taskSaveAsTemplate: function (taskId) { return BASE + '/tasks/' + taskId + '/save-as-template' },

  // ACL de pasta/lista/tarefa (permissoes-pasta-lista). Contêiner (pasta/lista)
  // usa um par GET/POST na coleção + PUT/DELETE na entrada (`permissionById`);
  // tarefa privada usa a lista COMPLETA de membros (GET/PUT) + DELETE por membro.
  // Backend layer: aawz_project_management.resources.resource_pm_permission.
  folderPermissions: function (folderId) { return BASE + '/folders/' + folderId + '/permissions' },
  sprintPermissions: function (sprintId) { return BASE + '/sprints/' + sprintId + '/permissions' },
  permissionById: function (id) { return BASE + '/permissions/' + id },
  taskMembers: function (taskId) { return BASE + '/tasks/' + taskId + '/members' },
  taskMemberById: function (taskId, profissionalId) { return BASE + '/tasks/' + taskId + '/members/' + profissionalId },

  // Duplicate View / espelhamento — backend: resource_pm_task_view.py
  taskViews: function (taskId) { return BASE + '/tasks/' + taskId + '/views' },
  taskViewById: function (taskId, mirrorId) { return BASE + '/tasks/' + taskId + '/views/' + mirrorId },

  // Trigger mappings (pm_task_template_trigger) — CRUD + filter by event_type.
  // Backend layer: aawz_project_management.resources.resource_pm_task_template_trigger
  triggerMappings: BASE + '/trigger-mappings',
  triggerMappingById: function (id) { return BASE + '/trigger-mappings/' + id },
  triggerMappingsByEvent: function (eventType) {
    return BASE + '/trigger-mappings?event_type=' + encodeURIComponent(eventType)
  },

  // Copy-list: duplicar lista (sprint) com preview
  sprintDuplicateSummary: function (id) { return BASE + '/sprints/' + id + '/duplicate-summary' },
  sprintDuplicate: function (id) { return BASE + '/sprints/' + id + '/duplicate' },

  // Copy-list: list templates (gestor)
  listTemplates: BASE + '/list-templates',
  listTemplateById: function (id) { return BASE + '/list-templates/' + id },
  listTemplateInstantiate: function (id) { return BASE + '/list-templates/' + id + '/instantiate' },
  sprintSaveAsTemplate: function (id) { return BASE + '/sprints/' + id + '/save-as-template' },
}
